import type { GalleryItem } from '../types/content'

// Visuels d’origine du carrousel de la landing argentine (récupérés depuis
// l’historique du projet), dans leur ordre d’origine.
export const originalGallery: GalleryItem[] = [
  {
    id: 'g1',
    motif: 'bouteilles fleuries',
    src: 'https://cdn.magicpatterns.com/uploads/kXpVrc4kFykriyoFwWDxkQ/carrusel_3.jpg',
    alt: 'Bouteilles en verre peintes de fleurs en faux vitrail',
  },
  {
    id: 'g2',
    motif: 'toucan',
    src: 'https://cdn.magicpatterns.com/uploads/vdeDyxESwB5JbZgZCfNBeq/carrusel_4.jpg',
    alt: 'Disque rond peint d’un toucan en faux vitrail, tenu à la main',
  },
  {
    id: 'g3',
    motif: 'panneau floral',
    src: 'https://cdn.magicpatterns.com/uploads/uFy89FxUUY6diSQRckna1N/carrusel_5.jpg',
    alt: 'Panneau floral en faux vitrail en cours de peinture',
  },
  {
    id: 'g4',
    motif: 'trio de bouteilles',
    src: 'https://cdn.magicpatterns.com/uploads/6tyBGPXE1LSgsUtZxERZJ6/carrusel_6.jpg',
    alt: 'Trois bouteilles décorées de fleurs en faux vitrail',
  },
  {
    id: 'g5',
    motif: 'vase tulipes',
    src: 'https://cdn.magicpatterns.com/uploads/hqGPV9QeBQ84RNWtMUheA1/carrusel_7.jpg',
    alt: 'Vase en verre peint de tulipes en faux vitrail',
  },
  {
    id: 'g6',
    motif: 'arc-en-ciel',
    src: 'https://cdn.magicpatterns.com/uploads/eML6rD22YJ2krS3KsVpnw5/carrusel_8.jpg',
    alt: 'Arc-en-ciel en faux vitrail suspendu',
  },
  {
    id: 'g7',
    motif: 'verre à pied',
    src: 'https://cdn.magicpatterns.com/uploads/p9eCGxnPDzH36xbAcxxB2Y/carrusel_9.jpg',
    alt: 'Verre à pied décoré de fleurs violettes en faux vitrail',
  },
  {
    id: 'g8',
    motif: 'tasse fleurie',
    src: 'https://cdn.magicpatterns.com/uploads/tDZefsvYpJkcgBzyA2gMBP/carrusel_10.jpg',
    alt: 'Tasse et soucoupe décorées de fleurs',
  },
]
